/* @jsx h */
import { defineComponent, h } from "vue";

export const AdminSettingsPage = defineComponent({
  name: "AdminSettingsPage",
  setup() {
    return () => (
      <div class="flex w-full flex-1 items-center justify-center p-6">
        <div class="rounded-3xl border border-base-300/60 bg-gradient-to-br from-base-100 to-base-200/30 px-10 py-16 text-center shadow-sm">
          <div class="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-accent/10 text-accent">
            <span class="material-symbols-outlined text-3xl">settings</span>
          </div>
          <h2 class="text-3xl font-semibold text-accent">Coming soon</h2>
          <p class="mt-3 text-sm text-base-content/65">
            Admin settings will be added here.
          </p>
        </div>
      </div>
    );
  },
});
